import { renderRoot } from "../constants/elements";

export const render = (html: Node, className?: string): void => {
  while (renderRoot.firstChild) {
    renderRoot.removeChild(renderRoot.firstChild);
  }
  renderRoot.append(html);
  renderRoot.className = className || "";
};
